<div class="main-div">
  <h1 class="main-header-text">Poruke upozorenja</h1>
  <div class="flex table-top-area">
    <div>
      <app-search></app-search>
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <button mat-icon-button [disableRipple]="true" (click)="openDialog()" class="ml-3">
        <mat-icon svgIcon="add" class="add" matTooltip="Generisanje poruka"></mat-icon>
      </button>
    </div>
  </div>
  <table class="table-style" mat-table [dataSource]="broadcastMessageData" matSort matSortActive="id" matSortDirection="desc">
    <ng-container matColumnDef="ID" class="id-width">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="TYPE">
      <th mat-header-cell *matHeaderCellDef>Tip poruke</th>
      <td mat-cell *matCellDef="let element">{{ element.type.name }}</td>
    </ng-container>

    <ng-container matColumnDef="MESSAGE">
      <th mat-header-cell *matHeaderCellDef>Tekst info poruke</th>
      <td mat-cell *matCellDef="let element">{{ element.infoMessage }}</td>
    </ng-container>

    <ng-container matColumnDef="AUDIO_MESSAGE">
      <th mat-header-cell *matHeaderCellDef>Tekst audio poruke</th>
      <td mat-cell *matCellDef="let element">{{ element.audioMessage }}</td>
    </ng-container>

    <ng-container matColumnDef="STATUS">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">{{ statusDescription(element.status) }}</td>
    </ng-container>

    <ng-container matColumnDef="CREATED_BY">
      <th mat-header-cell *matHeaderCellDef>Kreirao</th>
      <td mat-cell *matCellDef="let element">{{ element.createdBy }}</td>
    </ng-container>

    <ng-container matColumnDef="START_DATE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate">Početak<br/>emitovanja</th>
      <td mat-cell *matCellDef="let element">
        {{ element.startDate | date : 'HH:mm:ss' }}
        <br />
        {{ element.startDate | date : 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="UPDATED_BY">
      <th mat-header-cell *matHeaderCellDef>Ažurirao</th>
      <td mat-cell *matCellDef="let element">{{ element.updatedBy }}</td>
    </ng-container>

    <ng-container matColumnDef="END_DATE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="endDate">Kraj<br/>emitovanja</th>
      <td mat-cell *matCellDef="let element">
        {{ element.endDate | date : 'HH:mm:ss' }}
        <br />
        {{ element.endDate | date : 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ACTION">
      <th mat-header-cell *matHeaderCellDef class="p-0">Akcije</th>
      <td mat-cell *matCellDef="let element" class="cell-size-actions">
        <div class="cell-actions">
          <button *ngIf="element.status === BroadcastMessageStatus.READY" mat-icon-button (click)="cancel(element)">
            <mat-icon svgIcon="cancel" class="cancel" matTooltip="Otkaži poruku"></mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Nema rezultata za prikaz.
      </td>
    </tr>
  </table>
  <div class="paginator">
    <mat-paginator [length]="total" [pageSize]="pageSize" [hidePageSize]="true" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>
</div>
